<template>
<!-- Page Content Wrapper -->
<div id="page-content-wrapper" class="admin-content-area">
    <div class="container-fluid xyz">
        <div class="page-header-top-container">
            <div class="page-name" id="benefitHeader">
                Talent Management
            </div>
        </div>
        <!--page content-->

        <div class="admin-page-content talent-management">

        <div class="modal fade" id="exportView" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="defaultModalLabel">Export Data</h4>
                        <!--<button type="button" class="close" data-dismiss="modal">&times;</button>-->
                    </div>
                    <form class="form-inline">
                        <div class="modal-body">
                            Select Year
                            <v-select v-model="export_year"
                                name="sele_year" id="sele_year" :clearable="false"
                                label="name" :filterable="true" :options="sele_yearArr" placeholder="Select Year">
                            </v-select>
                            <font class="text-danger">{{export_yearerr}}</font>


                            <div class="form-group">
                                <label id="errorMsg" class="error"></label><br>
                            </div>
                            <br>
                            Select Grade
                            <v-select v-model="export_grade"
                                name="sele_grade" id="sele_grade"
                                label="name" :filterable="true" :options="sele_gradeArr"
                                :clearable="true"
                                placeholder="Select Grade">
                            </v-select>

                            <div class="d-flex justify-content-center">---- OR ----</div>
                            Select Manager/HR
                            <v-select v-model="export_user"
                                name="sele_grade" id="sele_grade" :clearable="true"
                                label="text" :filterable="true" :options="hr_managerArr" placeholder="Manager/HR">
                            </v-select>
                            <!-- label="name" :filterable="true" :options="hr_managerArr" placeholder="Manager/HR"> -->

                            <div class="d-flex justify-content-center">---- OR ----</div>
                            Select Location
                            <v-select v-model="export_location"
                                name="sele_grade" id="sele_grade" :clearable="true"
                                label="text" :filterable="true" :options="locationArr" placeholder="Location">
                            </v-select>
                            <div class="clearfix"></div>
                            <div class="row mt-3 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <button type="button" v-on:click="exportData();" class="btn btn-primary mr-2">Export</button>
                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">Close</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>




            <form id="talentManagement">
                <div class="forms-container">
                    <div class="top-header float-right">
                        <button type="button" data-toggle="modal" id="exportModel" title='Export'
                        data-target="#exportView" class="btn btn-primary waves-effect pull-right ml-2">Export</button>
                        <!-- <button type="submit" v-on:click.prevent="submitGrades()"
                        v-bind:class="{ disabledSelect: isDisableYear }"
                         class="btn btn-primary waves-effect pull-right">Submit</button> -->

                        <v-select v-model="year"
                        @input="changedValueYear()" name="sele_year" id="sele_year"
                        class="year-filter filter" :disable="true" :clearable="false" label="name" :filterable="true" :options="sele_yearArr" placeholder="Select Year">
                        </v-select>

                        <v-select v-if="isVisibleMAnagers" v-model="view_manager"
                        @input="changedValueView()" name="sele_year" id="sele_year"
                        class="year-filter filter" :disable="true" :clearable="true"
                        label="text" :filterable="true" :options="hr_managerArr"
                        placeholder="Select Manager/HR">
                        </v-select>
                        <!-- label="name" :filterable="true" :options="hr_managerArr" -->



                        <!--v-select
                                      v-model="quarter"
                                      @input="changedValueQuarter()"
                                      name="sele_emp"
                                      id="sele_emp"
                                      class="quaters-filter filter"
                                      :clearable="false"
                                      label="text"
                                      :filterable="true"
                                      :options="sele_quarterArr"

                                      placeholder="Select Quarter">
                                  </v-select-->
                    </div>


                    <div class="toggle1">

                        <div class="modal fade" id="viewMore" role="dialog">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h4 class="modal-title" id="defaultModalLabel">Grade {{ grade }} Users</h4>
                                        <!--<button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                    </div>
                                    <div class="modal-body">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <ul class="list-user">
                                                    <li v-for="( obj, index) in empList" style="list-style: decimal;">
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}
                                                        </a>
                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }"  aria-hidden="true" v-on:click.prevent="removeUser(obj, grade)"></i>
                                                    </li>
                                                </ul>
                                                <template v-if="empList == 0">
                                                    No User available
                                                </template>
                                            </div>
                                            <button data-dismiss="modal" type="submit" class="btn btn-primary float-right">Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="potential tree-toggle1">
                            <img src="/../static/images/potential.png" />
                            <span class="hide1 toggle-title">Performance <i aria-hidden="true" class="fa fa-angle-down"></i></span>
                        </div>
                        <div class="nine-box toggle-content desktop-content">
                            <div class="row no-gutters">

                                <div class="col-md-4 col-sm-12 sections">
                                    <div class="priority">high</div>
                                    <div class="header">
                                        <h4 class="title">C1</h4>
                                        <span class="search-section">
                                            <!--input type="text" id="dayForceId" placeholder="Type name here" class=""-->
                                            <v-select
                                            v-bind:class="{ disabledSelect: isDisableYear }"
                                              v-model="sele_empc1"
                                              @change="changedValue == null"
                                              @input="changedValueUser('c1',sele_empc1)"
                                              ref="c1"
                                              name="sele_emp"
                                              id="sele_emp"
                                              label="text"
                                              :filterable="true"
                                              :options="sele_empArr"
                                              :clearable="true"
                                              placeholder="Select User">
                                            </v-select>
                                            <!--i class="plus-square float-right" v-on:click.prevent="addUserGrade('c1')">+</i-->

                                        </span>
                                    </div>
                                    <ul class="list-user">
                                        <draggable class="list-group" :list="c1Emp" group="people" @change="log" :disabled='isDisableYear'>
                                            <template v-for="( obj, index) in c1Emp">
                                                <template v-if="index < 4">
                                                    <li>
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}
                                                        </a>

                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }" aria-hidden="true" v-on:click.prevent="removeUser(obj, 'c1')"></i>

                                                    </li>
                                                </template>
                                            </template>
                                        </draggable>
                                    </ul>
                                    <button type="button" data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary view-more" data-target="#viewMore" v-on:click.prevent="viewMore('C1', c1Emp)">View More</button>
                                    <!--button data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary" data-target="#viewMore" >View More</button-->
                                </div>
                                <div class="col-md-4 col-sm-12 sections">
                                    <div class="header">
                                        <h4 class="title">B1</h4>
                                        <span class="search-section">
                                            <!--input type="text" id="dayForceId" placeholder="Type name here" class=""-->
                                            <v-select
                                            v-bind:class="{ disabledSelect: isDisableYear }"
                                              v-model="sele_empb1"
                                              ref="b1"
                                              @change="changedValue"
                                              @input="changedValueUser('b1',sele_empArr)"
                                              name="sele_emp" id="sele_emp"
                                              label="text"
                                              :filterable="true"
                                              :options="sele_empArr"
                                              :clear="true"
                                              placeholder="Select User">
                                            </v-select>
                                            <!--i class="plus-square float-right" v-on:click.prevent="addUserGrade('b1')">+</i-->

                                        </span>
                                    </div>
                                    <ul class="list-user">
                                        <draggable class="list-group" :list="b1Emp" group="people" @change="log" :disabled='isDisableYear'>
                                            <template v-for="( obj, index) in b1Emp">
                                                <template v-if="index < 4">
                                                    <li>
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}</a>
                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }"  aria-hidden="true" v-on:click.prevent="removeUser(obj, 'b1')"></i>
                                                    </li>
                                                </template>
                                            </template>
                                        </draggable>
                                    </ul>

                                    <button type="button" data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary view-more" data-target="#viewMore" v-on:click.prevent="viewMore('B1', b1Emp)">View More</button>
                                </div>
                                <div class="col-md-4 col-sm-12 sections">
                                    <div class="header">
                                        <h4 class="title">A1</h4>
                                        <span class="search-section">
                                            <!--input type="text" id="dayForceId" placeholder="Type name here" class=""-->
                                            <v-select
                                            v-bind:class="{ disabledSelect: isDisableYear }" ref="a1"
                                              v-model="sele_empa1"
                                              @change="changedValue"
                                              @input="changedValueUser('a1',sele_empa1)"
                                              name="sele_emp"
                                              id="sele_emp"
                                              label="text"
                                              :filterable="true"
                                              :options="sele_empArr"
                                              placeholder="Select User">
                                            </v-select>
                                            <!--i class="plus-square float-right" v-on:click.prevent="addUserGrade('a1')">+</i-->
                                        </span>
                                    </div>
                                    <ul class="list-user">
                                        <draggable class="list-group" :list="a1Emp" group="people" @change="log" :disabled='isDisableYear'>
                                            <template v-for="( obj, index) in a1Emp">
                                                <template v-if="index < 4">
                                                    <li>
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}</a>
                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }"  aria-hidden="true" v-on:click.prevent="removeUser(obj, 'a1')"></i>
                                                    </li>
                                                </template>
                                            </template>
                                        </draggable>
                                    </ul>
                                    <button type="button" data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary view-more" data-target="#viewMore" v-on:click.prevent="viewMore('A1', a1Emp)">View More</button>
                                </div>
                            </div>
                            <div class="row no-gutters">
                                <div class="col-md-4 col-sm-12 sections">
                                    <div class="priority avrpriority">average</div>
                                    <div class="header">
                                        <h4 class="title">C2</h4>
                                        <span class="search-section">
                                            <!--input type="text" id="dayForceId" placeholder="Type name here" class=""-->
                                            <v-select
                                            v-bind:class="{ disabledSelect: isDisableYear }"
                                              ref="c2"
                                              v-model="sele_empc2"
                                              @change="changedValue"
                                              @input="changedValueUser('c2',sele_empc2)"
                                              name="sele_emp"
                                              id="sele_emp"
                                              label="text" :filterable="true"
                                              :options="sele_empArr"
                                              placeholder="Select User">
                                            </v-select>
                                            <!--i class="plus-square float-right" v-on:click.prevent="addUserGrade('c2')">+</i-->
                                        </span>
                                    </div>
                                    <ul class="list-user">
                                        <draggable class="list-group" :list="c2Emp" group="people" @change="log" :disabled='isDisableYear'>
                                            <template v-for="( obj, index) in c2Emp">
                                                <template v-if="index < 4">
                                                    <li>
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}</a>
                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }"  aria-hidden="true" v-on:click.prevent="removeUser(obj, 'c2')"></i>
                                                    </li>
                                                </template>
                                            </template>
                                        </draggable>
                                    </ul>
                                    <button type="button" data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary view-more" data-target="#viewMore" v-on:click.prevent="viewMore('C2', c2Emp)">View More</button>
                                </div>
                                <div class="col-md-4 col-sm-12 sections">
                                    <div class="header">
                                        <h4 class="title">B2</h4>
                                        <span class="search-section">
                                            <!--input type="text" id="dayForceId" placeholder="Type name here" class=""-->
                                            <v-select
                                            v-bind:class="{ disabledSelect: isDisableYear }"
                                              ref="b2"
                                              v-model="sele_empb2"
                                              @change="changedValue"
                                              @input="changedValueUser('b2',sele_empb2)"
                                              name="sele_emp"
                                              id="sele_emp"
                                              label="text"
                                              :filterable="true"
                                              :options="sele_empArr"
                                              placeholder="Select User">
                                            </v-select>
                                            <!--i class="plus-square float-right" v-on:click.prevent="addUserGrade('b2')">+</i-->
                                        </span>
                                    </div>
                                    <ul class="list-user">
                                        <draggable class="list-group" :list="b2Emp" group="people" @change="log" :disabled='isDisableYear'>
                                            <template v-for="( obj, index) in b2Emp">
                                                <template v-if="index < 4">
                                                    <li>
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}</a>
                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }"  aria-hidden="true" v-on:click.prevent="removeUser(obj, 'b2')"></i>
                                                    </li>
                                                </template>
                                            </template>
                                        </draggable>
                                    </ul>
                                    <button type="button" data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary view-more" data-target="#viewMore" v-on:click.prevent="viewMore('B2', b2Emp)">View More</button>
                                </div>
                                <div class="col-md-4 col-sm-12 sections">
                                    <div class="header">
                                        <h4 class="title">A2</h4>
                                        <span class="search-section">
                                            <!--input type="text" id="dayForceId" placeholder="Type name here" class=""-->
                                            <v-select
                                            v-bind:class="{ disabledSelect: isDisableYear }"
                                              ref="a2"
                                              v-model="sele_empa2"
                                              @change="changedValue"
                                              @input="changedValueUser('a2',sele_empa2)"
                                              name="sele_emp"
                                              id="sele_emp"
                                              label="text"
                                              :filterable="true"
                                              :options="sele_empArr"
                                              placeholder="Select User">
                                            </v-select>
                                            <!--i class="plus-square float-right" v-on:click.prevent="addUserGrade('a2')">+</i-->
                                        </span>
                                    </div>
                                    <ul class="list-user">
                                        <draggable class="list-group" :list="a2Emp" group="people" @change="log" :disabled='isDisableYear'>
                                            <template v-for="( obj, index) in a2Emp">
                                                <template v-if="index < 4">
                                                    <li>
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}</a>
                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }"  aria-hidden="true" v-on:click.prevent="removeUser(obj, 'a2')"></i>
                                                    </li>
                                                </template>
                                            </template>
                                        </draggable>
                                    </ul>
                                    <button type="button" data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary view-more" data-target="#viewMore" v-on:click.prevent="viewMore('A2', a2Emp)">View More</button>
                                </div>
                            </div>
                            <div class="row no-gutters">
                                <div class="col-md-4 col-sm-12 sections">
                                    <div class="priority">low</div>
                                    <div class="performance show1">low</div>
                                    <div class="header">
                                        <h4 class="title">C3</h4>
                                        <span class="search-section">
                                            <!--input type="text" id="dayForceId" placeholder="Type name here" class=""-->
                                            <v-select
                                            v-bind:class="{ disabledSelect: isDisableYear }"
                                              ref="c3"
                                              v-model="sele_empc3" @change="changedValue"
                                              @input="changedValueUser('c3',sele_empc3)" name="sele_emp"
                                              id="sele_emp" label="text" :filterable="true" :options="sele_empArr"
                                              placeholder="Select User">
                                            </v-select>
                                            <!--i class="plus-square float-right" v-on:click.prevent="addUserGrade('c3')">+</i-->
                                        </span>
                                    </div>
                                    <ul class="list-user">
                                        <draggable class="list-group" :list="c3Emp" group="people" @change="log" :disabled='isDisableYear'>
                                            <template v-for="( obj, index) in c3Emp">
                                                <template v-if="index < 4">
                                                    <li>
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}</a>
                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }"  aria-hidden="true" v-on:click.prevent="removeUser(obj, 'c3')"></i>
                                                    </li>
                                                </template>
                                            </template>
                                        </draggable>
                                    </ul>
                                    <button type="button" data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary view-more" data-target="#viewMore" v-on:click.prevent="viewMore('C3', c3Emp)">View More</button>
                                </div>
                                <div class="col-md-4 col-sm-12 sections">
                                    <div class="performance show1">average</div>
                                    <div class="header">
                                        <h4 class="title">B3</h4>
                                        <span class="search-section">
                                            <!--input type="text" id="dayForceId" placeholder="Type name here" class=""-->
                                            <v-select
                                            v-bind:class="{ disabledSelect: isDisableYear }"
                                              ref="b3"
                                              v-model="sele_empb3"
                                              @change="changedValue"
                                              @input="changedValueUser('b3',sele_empb3)"
                                              name="sele_emp"
                                              id="sele_emp"
                                              label="text"
                                              :filterable="true"
                                              :options="sele_empArr"
                                              placeholder="Select User">
                                            </v-select>
                                            <!--i class="plus-square float-right" v-on:click.prevent="addUserGrade('b3')">+</i-->
                                        </span>
                                    </div>
                                    <ul class="list-user">
                                        <draggable class="list-group" :list="b3Emp" group="people" @change="log" :disabled='isDisableYear'>
                                            <template v-for="( obj, index) in b3Emp">
                                                <template v-if="index < 4">
                                                    <li>
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}</a>
                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }"  aria-hidden="true" v-on:click.prevent="removeUser(obj, 'b3')"></i>
                                                    </li>
                                                </template>
                                            </template>
                                        </draggable>
                                    </ul>
                                    <button type="button" data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary view-more" data-target="#viewMore" v-on:click.prevent="viewMore('B3', b3Emp)">View More</button>
                                </div>
                                <div class="col-md-4 col-sm-12 sections">
                                    <div class="performance desk-content">high</div>
                                    <div class="header">
                                        <h4 class="title">A3</h4>
                                        <span class="search-section">
                                            <!--input type="text" id="dayForceId" placeholder="Type name here" class=""-->
                                            <v-select
                                            v-bind:class="{ disabledSelect: isDisableYear }"
                                              ref="a3"
                                              v-model="sele_empa3"
                                              @change="changedValue"
                                              @input="changedValueUser('a3',sele_empa3)"
                                              name="sele_emp"
                                              id="sele_emp"
                                              label="text"
                                              :filterable="true"
                                              :options="sele_empArr"
                                              placeholder="Select User">
                                            </v-select>
                                            <!--i class="plus-square float-right" v-on:click.prevent="addUserGrade('a3')">+</i-->
                                        </span>
                                    </div>
                                    <ul class="list-user">
                                        <draggable class="list-group" :list="a3Emp" group="people" @change="log" :disabled='isDisableYear'>
                                            <template v-for="( obj, index) in a3Emp">
                                                <template v-if="index < 4">
                                                    <li>
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}</a>
                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }"  aria-hidden="true" v-on:click.prevent="removeUser(obj, 'a3')"></i>
                                                    </li>
                                                </template>
                                            </template>
                                        </draggable>
                                    </ul>
                                    <button type="button" data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary view-more" data-target="#viewMore" v-on:click.prevent="viewMore('A3', a3Emp)">View More</button>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="toggle2">
                        <div class="performance tree-toggle1">
                            <img src="/../static/images/performance.png" />
                            <span class="hide1 toggle-title">Potential <i aria-hidden="true" class="fa fa-angle-down"></i></span>
                        </div>
                        <div class="nine-box toggle-content mobile-content">
                            <div class="row no-gutters">
                                <div class="col-md-4 col-sm-12 sections">
                                    <div class="priority">low</div>
                                    <div class="header">
                                        <h4 class="title">C1</h4>
                                        <span class="search-section">
                                            <!--input type="text" id="dayForceId" placeholder="Type name here" class=""-->
                                            <v-select
                                            v-bind:class="{ disabledSelect: isDisableYear }"
                                            ref="c1"
                                            v-model="sele_empc1" @change="changedValue"
                                            @input="changedValueUser('c1',sele_empc1)" name="sele_emp" id="sele_emp"
                                            label="text" :filterable="true" :options="sele_empArr"
                                            placeholder="Select User">
                                            </v-select>
                                            <!--i class="plus-square float-right" v-on:click.prevent="addUserGrade('c1')">+</i-->

                                        </span>
                                    </div>
                                    <ul class="list-user">
                                        <draggable class="list-group" :list="c1Emp" group="people" @change="log" :disabled='isDisableYear'>
                                            <template v-for="( obj, index) in c1Emp">
                                                <template v-if="index < 4">
                                                    <li>
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}</a>
                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }"  aria-hidden="true" v-on:click.prevent="removeUser(obj, 'c1')"></i>
                                                    </li>
                                                </template>
                                            </template>
                                        </draggable>
                                    </ul>
                                    <button type="button" data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary view-more" data-target="#viewMore" v-on:click.prevent="viewMore('C1', c1Emp)">View More</button>
                                </div>
                                <div class="col-md-4 col-sm-12 sections">
                                    <div class="header">
                                        <h4 class="title">C2</h4>
                                        <span class="search-section">
                                            <!--input type="text" id="dayForceId" placeholder="Type name here" class=""-->
                                            <v-select
                                            v-bind:class="{ disabledSelect: isDisableYear }"
                                              ref="c2"
                                              v-model="sele_empc2" @change="changedValue"
                                              @input="changedValueUser('c2',sele_empc2)" name="sele_emp"
                                              id="sele_emp" label="text" :filterable="true" :options="sele_empArr"
                                              placeholder="Select User">
                                            </v-select>
                                            <!--i class="plus-square float-right" v-on:click.prevent="addUserGrade('c2')">+</i-->
                                        </span>
                                    </div>
                                    <ul class="list-user">
                                        <draggable class="list-group" :list="c2Emp" group="people" @change="log" :disabled='isDisableYear'>
                                            <template v-for="( obj, index) in c2Emp">
                                                <template v-if="index < 4">
                                                    <li>
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}</a>
                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }"  aria-hidden="true" v-on:click.prevent="removeUser(obj, 'c2')"></i>
                                                    </li>
                                                </template>
                                            </template>
                                        </draggable>
                                    </ul>
                                    <button type="button" data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary view-more" data-target="#viewMore" v-on:click.prevent="viewMore('C2', c2Emp)">View More</button>
                                </div>
                                <div class="col-md-4 col-sm-12 sections">
                                    <div class="header">
                                        <h4 class="title">C3</h4>
                                        <span class="search-section">
                                            <!--input type="text" id="dayForceId" placeholder="Type name here" class=""-->
                                            <v-select
                                            v-bind:class="{ disabledSelect: isDisableYear }"
                                            ref="c3"
                                             v-model="sele_empc3" @change="changedValue" @input="changedValueUser('c3',sele_empc3)" name="sele_emp"
                                             id="sele_emp" label="text" :filterable="true" :options="sele_empArr"
                                             placeholder="Select User">
                                            </v-select>
                                            <!--i class="plus-square float-right" v-on:click.prevent="addUserGrade('c3')">+</i-->
                                        </span>
                                    </div>
                                    <ul class="list-user">
                                        <draggable class="list-group" :list="c3Emp" group="people" @change="log" :disabled='isDisableYear'>
                                            <template v-for="( obj, index) in c3Emp">
                                                <template v-if="index < 4">
                                                    <li>
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}</a>
                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }"  aria-hidden="true" v-on:click.prevent="removeUser(obj, 'c3')"></i>
                                                    </li>
                                                </template>
                                            </template>
                                        </draggable>
                                    </ul>
                                    <button type="button" data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary view-more" data-target="#viewMore" v-on:click.prevent="viewMore('C3', c3Emp)">View More</button>
                                </div>
                            </div>
                            <div class="row no-gutters">
                                <div class="col-md-4 col-sm-12 sections">
                                    <div class="priority avrpriority">average</div>
                                    <div class="header">
                                        <h4 class="title">B1</h4>
                                        <span class="search-section">
                                            <!--input type="text" id="dayForceId" placeholder="Type name here" class=""-->
                                            <v-select
                                            v-bind:class="{ disabledSelect: isDisableYear }"
                                            ref="b1"
                                            v-model="sele_empb1" @change="changedValue" @input="changedValueUser('b1',sele_empb1)" name="sele_emp" id="sele_emp" label="text" :filterable="true" :options="sele_empArr" placeholder="Select User">
                                            </v-select>
                                            <!--i class="plus-square float-right" v-on:click.prevent="addUserGrade('b1')">+</i-->

                                        </span>
                                    </div>
                                    <ul class="list-user">
                                        <draggable class="list-group" :list="b1Emp" group="people" @change="log" :disabled='isDisableYear'>
                                            <template v-for="( obj, index) in b1Emp">
                                                <template v-if="index < 4">
                                                    <li>
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}</a>
                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }"  aria-hidden="true" v-on:click.prevent="removeUser(obj, 'b1')"></i>
                                                    </li>
                                                </template>
                                            </template>
                                        </draggable>
                                    </ul>
                                    <button type="button" data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary view-more" data-target="#viewMore" v-on:click.prevent="viewMore('B1', b1Emp)">View More</button>
                                </div>
                                <div class="col-md-4 col-sm-12 sections">
                                    <div class="header">
                                        <h4 class="title">B2</h4>
                                        <span class="search-section">
                                            <!--input type="text" id="dayForceId" placeholder="Type name here" class=""-->
                                            <v-select
                                            v-bind:class="{ disabledSelect: isDisableYear }"
                                            ref="b2"
                                            v-model="sele_empb2" @change="changedValue" @input="changedValueUser('b2',sele_empb2)" name="sele_emp" id="sele_emp" label="text" :filterable="true" :options="sele_empArr"  placeholder="Select User">
                                            </v-select>
                                            <!--i class="plus-square float-right" v-on:click.prevent="addUserGrade('b2')">+</i-->
                                        </span>
                                    </div>
                                    <ul class="list-user">
                                        <draggable class="list-group" :list="b2Emp" group="people" @change="log" :disabled='isDisableYear'>
                                            <template v-for="( obj, index) in b2Emp">
                                                <template v-if="index < 4">
                                                    <li>
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}</a>
                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }"  aria-hidden="true" v-on:click.prevent=" removeUser(obj, 'b2')"></i>
                                                    </li>
                                                </template>
                                            </template>
                                        </draggable>
                                    </ul>
                                    <button type="button" data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary view-more" data-target="#viewMore" v-on:click.prevent="viewMore('B2', b2Emp)">View More</button>
                                </div>
                                <div class="col-md-4 col-sm-12 sections">
                                    <div class="header">
                                        <h4 class="title">B3</h4>
                                        <span class="search-section">
                                            <!--input type="text" id="dayForceId" placeholder="Type name here" class=""-->
                                            <v-select
                                            v-bind:class="{ disabledSelect: isDisableYear }"
                                            ref="b3"
                                            v-model="sele_empb3" @change="changedValue" @input="changedValueUser('b3',sele_empb3)" name="sele_emp" id="sele_emp" label="text" :filterable="true" :options="sele_empArr"  placeholder="Select User">
                                            </v-select>
                                            <!--i class="plus-square float-right" v-on:click.prevent="addUserGrade('b3')">+</i-->
                                        </span>
                                    </div>
                                    <ul class="list-user">
                                        <draggable class="list-group" :list="b3Emp" group="people" @change="log" :disabled='isDisableYear'>
                                            <template v-for="( obj, index) in b3Emp">
                                                <template v-if="index < 4">
                                                    <li>
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}</a>
                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }"  aria-hidden="true" v-on:click.prevent=" removeUser(obj, 'b3')"></i>
                                                    </li>
                                                </template>
                                            </template>
                                        </draggable>
                                    </ul>
                                    <button type="button" data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary view-more" data-target="#viewMore" v-on:click.prevent="viewMore('B3', B3Emp)">View More</button>
                                </div>
                            </div>
                            <div class="row no-gutters">
                                <div class="col-md-4 col-sm-12 sections">
                                    <div class="priority">high</div>
                                    <div class="header">
                                        <h4 class="title">A1</h4>
                                        <span class="search-section">
                                            <!--input type="text" id="dayForceId" placeholder="Type name here" class=""-->
                                            <v-select
                                            v-bind:class="{ disabledSelect: isDisableYear }"
                                            ref="a1" v-model="sele_empa1" @change="changedValue" @input="changedValueUser('a1',sele_empa1)" name="sele_emp" id="sele_emp" label="text" :filterable="true" :options="sele_empArr"  placeholder="Select User">
                                            </v-select>
                                            <!--i class="plus-square float-right" v-on:click.prevent="addUserGrade('a1')">+</i-->
                                        </span>
                                    </div>
                                    <ul class="list-user">
                                        <draggable class="list-group" :list="a1Emp" group="people" @change="log" :disabled='isDisableYear'>
                                            <template v-for="( obj, index) in a1Emp">
                                                <template v-if="index < 4">
                                                    <li>
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}</a>
                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }"  aria-hidden="true" v-on:click.prevent=" removeUser(obj, 'a1')"></i>
                                                    </li>
                                                </template>
                                            </template>
                                        </draggable>
                                    </ul>
                                    <button type="button" data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary view-more" data-target="#viewMore" v-on:click.prevent="viewMore('A1', a1Emp)">View More</button>
                                </div>
                                <div class="col-md-4 col-sm-12 sections">
                                    <div class="performance show1">average</div>
                                    <div class="header">
                                        <h4 class="title">A2</h4>
                                        <span class="search-section">
                                            <!--input type="text" id="dayForceId" placeholder="Type name here" class=""-->
                                            <v-select
                                            v-bind:class="{ disabledSelect: isDisableYear }" ref="a2"
                                            v-model="sele_empa2" @change="changedValue" @input="changedValueUser('a2',sele_empa2)" name="sele_emp" id="sele_emp" label="text" :filterable="true" :options="sele_empArr"  placeholder="Select User">
                                            </v-select>
                                            <!--i class="plus-square float-right" v-on:click.prevent="addUserGrade('a2')">+</i-->
                                        </span>
                                    </div>
                                    <ul class="list-user">
                                        <draggable class="list-group" :list="a2Emp" group="people" @change="log" :disabled='isDisableYear'>
                                            <template v-for="( obj, index) in a2Emp">
                                                <template v-if="index < 4">
                                                    <li>
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}</a>
                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }"  aria-hidden="true" v-on:click.prevent=" removeUser(obj, 'a2')"></i>
                                                    </li>
                                                </template>
                                            </template>
                                        </draggable>
                                    </ul>
                                    <button type="button" data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary view-more" data-target="#viewMore" v-on:click.prevent="viewMore('A2', a2Emp)">View More</button>
                                </div>
                                <div class="col-md-4 col-sm-12 sections">
                                    <div class="header">
                                        <h4 class="title">A3</h4>
                                        <span class="search-section">
                                            <!--input type="text" id="dayForceId" placeholder="Type name here" class=""-->
                                            <v-select
                                            v-bind:class="{ disabledSelect: isDisableYear }" ref="a3"
                                            v-model="sele_empa3" @change="changedValue" @input="changedValueUser('a3',sele_empa3)" name="sele_emp" id="sele_emp" label="text" :filterable="true" :options="sele_empArr"  placeholder="Select User">
                                            </v-select>
                                            <!--i class="plus-square float-right" v-on:click.prevent="addUserGrade('a3')">+</i-->
                                        </span>
                                    </div>
                                    <ul class="list-user">
                                        <draggable class="list-group" :list="a3Emp" group="people" @change="log" :disabled='isDisableYear'>
                                            <template v-for="( obj, index) in a3Emp">
                                                <template v-if="index < 4">
                                                    <li>
                                                        <a href="javascript:void(0)" v-on:click.prevent="showProfile(obj.value)">{{ obj.text }}</a>
                                                        <i class="fa fa-times ml-5" v-bind:class="{ disableclick: isDisableYear }"  aria-hidden="true" v-on:click.prevent=" removeUser(obj, 'a3')"></i>
                                                    </li>
                                                </template>
                                            </template>
                                        </draggable>
                                    </ul>
                                    <button type="button" data-toggle="modal" id="viewMoreModel" title='View More' class="btn btn-primary view-more" data-target="#viewMore" v-on:click.prevent="viewMore('A3', a3Emp)">View More</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <!--page content-->
            </form>

        </div>

    </div>
    <app-backend-footer></app-backend-footer>
</div>
<!-- /#page-content-wrapper -->
</template>

<script>
import vSelect from 'vue-select'
import BackendFooter from '@/components/backend/partials/Footer'
import Vue from 'vue'
import SessioMixin from '../../../mixins/sessionmixin'
import EventBus from '../../event-bus'
import {
    HTTP
} from '../../../http-common'
import moment from 'moment'

import VueSweetalert2 from 'vue-sweetalert2';

import Multiselect from 'vue-multiselect';


Vue.use(VueSweetalert2);

import draggable from 'vuedraggable';
Vue.use(draggable);

var self

// Vue.use(VueCroppie);
export default {
    name: 'Login',
    props: [''],
    mixins: [SessioMixin],
    components: {
        'v-select': vSelect,
        'app-backend-footer': BackendFooter,
        draggable,
        Multiselect,
    },
    data() {
        return {
            roleId: 0,
            userId: 0,
            isDisableYear: true,

            export_location: '',
            locationArr: [],
            export_user: '',
            hr_managerArr: [],
            export_grade: '',
            sele_gradeArr: ["A1", "A2", "A3", "B1", "B2", "B3", "C1", "C2", "C3"],
            export_year: '',
            export_yearerr: '',
            selectedUsers: [],
            empList: [],
            grade: '',
            year: '',
            currentYear: '',
            sele_yearArr: [],

            quarter: '',
            sele_quarterArr: ["1st Quarter", "2nd Quarter", "3rd Quarter", "4th Quarter"],

            sele_empc1: '',
            sele_empb1: '',
            sele_empa1: '',

            sele_empc2: '',
            sele_empb2: '',
            sele_empa2: '',

            sele_empc3: '',
            sele_empb3: '',
            sele_empa3: '',

            sele_empArr: [],
            c1Emp: [],
            c2Emp: [],
            c3Emp: [],
            b1Emp: [],
            b2Emp: [],
            b3Emp: [],
            a1Emp: [],
            a2Emp: [],
            a3Emp: [],

            view_manager: '',
            isVisibleMAnagers: false,

        }
    },
    beforeMount: function () {
        self = this

    },
    mounted: function () {
        self = this;
        var userObj = localStorage.getItem("user_obj");
        var userJson = JSON.parse(userObj);
        self.userId = userJson.id;
        self.roleId = userJson.role.id;

        self.checkLogin();
        self.getHrAndManagers();
        self.loadLocations();



        if ($(window).width() < 960) {
            $('.tree-toggle1').click(function () {
                $(this).parent().children('.toggle-content').toggle(200);
                if ($(this).find('.toggle-title').children().attr('class').indexOf('fa-angle-down') != -1) {
                    $(this).find('.toggle-title').children().addClass('fa-angle-up');
                    $(this).find('.toggle-title').children().removeClass('fa-angle-down');
                } else {
                    $(this).find('.toggle-title').children().removeClass('fa-angle-up');
                    $(this).find('.toggle-title').children().addClass('fa-angle-down');
                }
            });
        }
        $(window).resize(function () {
            if ($(window).width() > 960) {
                $('.talent-management .desktop-content').show();
            }
        });
        var dt = new Date();
        if (localStorage.getItem('year') != null) {
            self.year = localStorage.getItem('year');
        } else {
            self.year = dt.getFullYear();
        }
        self.currentYear = dt.getFullYear();
        if(self.year == self.currentYear) {
          self.isDisableYear = true;
        } else {

          if(userJson.role.id <= 1) {
            self.isDisableYear = true;
          } else {
            self.isDisableYear = false;
          }
        }


        console.log("isDisableYear ==", self.isDisableYear)

        // var tdy = new Date();
        // self.currentYear = tdy.getFullYear();
        self.ListOfYears();
        if (this.$route.query.from == 'talentprofile') {
            if (localStorage.getItem('c1Emp') != null) {
                self.c1Emp = JSON.parse(localStorage.getItem("c1Emp"));
            }
            if (localStorage.getItem('c2Emp') != null) {
                self.c2Emp = JSON.parse(localStorage.getItem("c2Emp"));
            }
            if (localStorage.getItem('c3Emp') != null) {
                self.c3Emp = JSON.parse(localStorage.getItem("c3Emp"));
            }
            if (localStorage.getItem('b1Emp') != null) {
                self.b1Emp = JSON.parse(localStorage.getItem("b1Emp"));
            }
            if (localStorage.getItem('b2Emp') != null) {
                self.b2Emp = JSON.parse(localStorage.getItem("b2Emp"));
            }
            if (localStorage.getItem('b3Emp') != null) {
                self.b3Emp = JSON.parse(localStorage.getItem("b3Emp"));
            }
            if (localStorage.getItem('a1Emp') != null) {
                self.a1Emp = JSON.parse(localStorage.getItem("a1Emp"));
            }
            if (localStorage.getItem('a2Emp') != null) {
                self.a2Emp = JSON.parse(localStorage.getItem("a2Emp"));
            }
            if (localStorage.getItem('a3Emp') != null) {
                self.a3Emp = JSON.parse(localStorage.getItem("a3Emp"));
            }
            if (localStorage.getItem('quarter') != null) {
                self.quarter = localStorage.getItem("quarter");
            }
        }

    },
    watch: {
      export_year: function(export_year) {
        if(export_year != '') {
          self.export_yearerr = "";
        }

      },

      year: function(year) {

        if(self.year === self.currentYear) {
          console.log("YES");
          self.isDisableYear = false;
        } else {
          console.log("NO");
          if(self.roleId <= 1) {
            self.isDisableYear = false;
          } else {
            self.isDisableYear = true;
          }
        }
      }

    },
    methods: {
        getHrAndManagers: function() {
          var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                      except_self : self.userId
                    }
                };
                HTTP.get('gethrandmanager', config)
                    .then(function (response) {
                      self.hr_managerArr = response.data.content;
                    }).catch(function (err) {
                        // $('#exportUsers').text('Export');
                        // $('#exportUsers').prop("disabled", false);
                        if (err.response.status == 0) {
                            if (err.response.status == 0) {


                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        }
                        self.exportUsers = false;
                    });

        },
        loadLocations(loading, search, vm) {
            search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
            var data = {
                search: search
            };
            HTTP.post("getlocation", data)
                    .then(function (response) {
                        /*self.locationArr = response.data.content;*/
                        $.each(response.data.content, function (i) {
                            if (response.data.content[i].value != 0) {
                                self.locationArr.push(response.data.content[i]);
                            }
                        });
                        // if (typeof (loading) != "undefined") {
                        //     // loading(false);
                        // }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    });
        },
        exportData: function () {
          if(self.export_year == "" || self.export_year == null || self.export_year == undefined) {
            self.export_yearerr = "Please select year";
          } else {
            var config = {
                headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
            };
            var fields = {
                year: self.export_year,
                grade: self.export_grade,
                location: self.export_location.value,
                user: self.export_user.id,
            };
            self.showLoader();
            HTTP.post('export', fields, config)
                .then(function (response) {
                  if(response.data.code == 200) {
                    if (response.data.message == "success export") {
                        location.href = response.data.content.web;
                    } else {
                      self.limitExide(response.data.message);
                    }
                  } else if(response.data.code == 400) {

                    $('#exportView').modal('hide');
                    self.limitExide(response.data.message);
                  } else {
                    $('#exportView').modal('hide');
                    self.limitExide("Remote server can not be reachable");
                  }
                    self.hideLoader();
                    self.export_year = '';
                    self.export_grade = '';
                    self.export_location = '';
                    self.export_user = '';
                    $('#exportView').modal('hide');
                }).catch(function (err) {
                    // $('#exportUsers').text('Export');
                    // $('#exportUsers').prop("disabled", false);
                    if (err.response.status == 0) {
                        if (err.response.status == 0) {
                          self.limitExide("Remote server can not be reachable");

                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    }
                    self.exportUsers = false;
                    self.hideLoader();
                });

          }

        },
        log: function (evt) {
            console.log(evt);
            if(evt.added) {
              self.submitGrades();
            }

        },
        viewMore(grade, list) {
            self.grade = grade;
            self.empList = list;
        },
        removeUser: function (id, grade) {
            self.sele_empArr.push(id)
            grade = grade.toLowerCase();
            var idxAll = self.selectedUsers.findIndex(obj => obj == id.value);
            if (idxAll != null) {
                self.selectedUsers.splice(idxAll, 1);
            }


            switch (grade) {
                case 'c1':
                    var idx = self.c1Emp.findIndex(obj => obj.value == id.value);
                    if (idx != -1) {
                        self.c1Emp.splice(idx, 1);
                        setTimeout(function() { self.submitGrades(); },100);
                    }
                    break;
                case 'b1':
                    var idx = self.b1Emp.findIndex(obj => obj.value == id.value);
                    if (idx != -1) {
                        self.b1Emp.splice(idx, 1);
                        setTimeout(function() { self.submitGrades(); },100);
                    }
                    break;

                case 'a1':
                    var idx = self.a1Emp.findIndex(obj => obj.value == id.value);
                    if (idx != -1) {
                        self.a1Emp.splice(idx, 1);
                        setTimeout(function() { self.submitGrades(); },100);
                    }
                    break;

                case 'c2':
                    var idx = self.c2Emp.findIndex(obj => obj.value == id.value);
                    if (idx != -1) {
                        self.c2Emp.splice(idx, 1);
                        setTimeout(function() { self.submitGrades(); },100);
                    }
                    break;

                case 'b2':
                    var idx = self.b2Emp.findIndex(obj => obj.value == id.value);
                    if (idx != -1) {
                        self.b2Emp.splice(idx, 1);
                        setTimeout(function() { self.submitGrades(); },100);
                    }
                    break;

                case 'a2':
                    var idx = self.a2Emp.findIndex(obj => obj.value == id.value);
                    if (idx != -1) {
                        self.a2Emp.splice(idx, 1);
                        setTimeout(function() { self.submitGrades(); },100);
                    }
                    break;

                case 'c3':
                    var idx = self.c3Emp.findIndex(obj => obj.value == id.value);
                    if (idx != -1) {
                        self.c3Emp.splice(idx, 1);
                        setTimeout(function() { self.submitGrades(); },100);
                    }
                    break;

                case 'b3':
                    var idx = self.b3Emp.findIndex(obj => obj.value == id.value);
                    if (idx != null) {
                        self.b3Emp.splice(idx, 1);
                        setTimeout(function() { self.submitGrades(); },100);
                    }
                    break;

                case 'a3':
                    var idx = self.b3Emp.findIndex(obj => obj.value == id.value);
                    if (idx != null) {
                        self.a3Emp.splice(idx, 1);
                        setTimeout(function() { self.submitGrades(); },100);
                    }
                    break;
                default:
                    break;
            }
        },
        checkForm: function () {
            var checked = true;
            return checked;
            // self.nameError = "";
            self.dependentUsersError = "";
            if (self.c1Emp.length > 0 || self.c2Emp.length > 0 || self.c3Emp.length > 0 ||
                self.b1Emp.length > 0 || self.b2Emp.length > 0 || self.b3Emp.length > 0 ||
                self.a1Emp.length > 0 || self.a2Emp.length > 0 || self.a3Emp.length > 0) {} else {
                if (checked) {
                    self.limitExide('Please add employees for grades');
                    checked = false;
                }
            }
            return checked;
        },
        getEmpAndGrades: function (list, gradeName) {

            if (list.length > 0) {
                var emps = []
                list.forEach(element => {
                    emps.push(element.value);
                });
                var garde = {
                    grade: gradeName,
                    employees: emps,
                }
                return garde;
            }
        },
        clearForm: function () {
            self.sele_empc1 = '';
            self.sele_empb1 = '';
            self.sele_empa1 = '';
            self.sele_empc2 = '';
            self.sele_empb2 = '';
            self.sele_empa2 = '';
            self.sele_empc3 = '';
            self.sele_empb3 = '';
            self.sele_empa3 = '';
            self.c1Emp = [];
            self.c2Emp = [];
            self.c3Emp = [];
            self.b1Emp = [];
            self.b2Emp = [];
            self.b3Emp = [];
            self.a1Emp = [];
            self.a2Emp = [];
            self.a3Emp = [];

            var dt = new Date();
            // self.year = dt.getFullYear();
            self.quarter = self.sele_quarterArr[self.getQuarter() - 1];

            localStorage.removeItem("c1Emp");
            localStorage.removeItem("c2Emp");
            localStorage.removeItem("c3Emp");
            localStorage.removeItem("b1Emp");
            localStorage.removeItem("b2Emp");
            localStorage.removeItem("b3Emp");
            localStorage.removeItem("a1Emp");
            localStorage.removeItem("a2Emp");
            localStorage.removeItem("a3Emp");
            localStorage.removeItem("quarter");
            localStorage.removeItem("year");
            // self.selectedUsers = [];
        },
        submitGrades: function () {

            if (self.checkForm()) {

                var config = {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("api_token")
                    }
                };

                var grades = []
                if (self.c1Emp.length > 0) {
                    grades.push(self.getEmpAndGrades(self.c1Emp, "c1"));
                }

                if (self.c2Emp.length > 0) {
                    grades.push(self.getEmpAndGrades(self.c2Emp, "c2"));
                }
                if (self.c3Emp.length > 0) {
                    grades.push(self.getEmpAndGrades(self.c3Emp, "c3"));
                }
                if (self.b1Emp.length > 0) {
                    grades.push(self.getEmpAndGrades(self.b1Emp, "b1"));
                }
                if (self.b2Emp.length > 0) {
                    grades.push(self.getEmpAndGrades(self.b2Emp, "b2"));
                }
                if (self.b3Emp.length > 0) {
                    grades.push(self.getEmpAndGrades(self.b3Emp, "b3"));
                }
                if (self.a1Emp.length > 0) {
                    grades.push(self.getEmpAndGrades(self.a1Emp, "a1"));
                }
                if (self.a2Emp.length > 0) {
                    grades.push(self.getEmpAndGrades(self.a2Emp, "a2"));
                }
                if (self.a3Emp.length > 0) {
                    grades.push(self.getEmpAndGrades(self.a3Emp, "a3"));
                }
                // console.log(self.view_manager);


                if(self.view_manager != null && self.view_manager != "") {
                    var fields = {
                        quarter: self.quarter,
                        year: self.year,
                        grades: grades,
                        reporting_to: self.view_manager.id,
                    };
                } else {
                  var userObj = localStorage.getItem("user_obj");
                  var userJson = JSON.parse(userObj);
                  // self.view_manager = {
                  //   id : ,
                  //   name : userJson.first_name + " " + userJson.last_name,
                  //   role: userJson.role.name
                  // }
                    var fields = {
                      quarter: self.quarter,
                      year: self.year,
                      grades: grades,
                      reporting_to: userJson.id,
                    };
                }
                self.showLoader();
                HTTP.post("multiple_grades", fields, config)
                    .then(function (response) {
                        if (response.data.status == "success") {
                            // self.clearForm();
                            self.getGradesByQuarterAndYear();
                            // self.$swal({
                            //     type: 'success',
                            //     text: response.data.message,
                            //     showConfirmButton: false,
                            //     timer: 5000,
                            // });
                        } else {
                            $("#errorMsg").html(response.data.message);
                            if (response.data.content.length > 0) {
                                var err = "";
                                err += response.data.content + "<br>";
                                $("#errorMsg").html(err);
                            }
                        }
                        self.hideLoader();
                    })
                    .catch(function (err) {
                        $("#save").val("Save");
                        $("#save").prop("disabled", false);
                        self.Registerbtn = "Register";
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            $('#errorMsg').html(err.response.data.message);
                        }
                        self.hideLoader();
                    });

            }
        },
        ListOfYears: function () {
            var currentYear = new Date().getFullYear(),
                years = [];
            var startYear = 2000;
            while (startYear <= currentYear) {
                years.push(startYear++);
            }
            self.sele_yearArr = years.reverse();
            self.quarter = self.sele_quarterArr[self.getQuarter() - 1];
        },
        getQuarter: function () {
            var d = new Date();
            var month = d.getMonth() + 1;
            return (Math.ceil(month / 3));
        },
        changedValue: function (value) {
            // console.log(value);
        },
        onSearchUser(search, loading) {
          console.log("onSearchUser");
            let self = this
            /* if (self.siteid != null && self.siteid != "") { */
            // if (search.length > 2) {
            //     if (typeof (loading) !== 'undefined') {
            //         loading(true)
            //     }
            //     self.loadUsers(loading, search, this)
            // }
            /* } */
            // if (typeof (loading) !== 'undefined') {
            //     loading(true)
            // }
            // self.loadUsers(loading, search, this)
        },
        changedValueQuarter: function () {
            // self.frontendErrors.sele_empError = "";
        },
        changedValueYear: function () {
          console.log("CHANGE YEAR");
            self.selectedUsers = [];
            self.clearForm();

            self.getGradesByQuarterAndYear();
            // self.frontendErrors.sele_empError = "";
        },
        changedValueUser: function (grade, val) {
          // console.log("changedValueUser");
            if (grade != null) {
                self.addUserGrade(grade);
            }
            // self.frontendErrors.sele_empError = "";
        },
        changedValueView: function() {
          console.log("changedValueView");
          console.log(self.view_manager);
          if(self.view_manager != "" ) {
            // self.loadUsers(true, '', this)
            self.getGradesByQuarterAndYear();
          } else if(self.view_manager == null)  {
            self.view_manager = '';
            self.clearForm();
            self.loadUsers(true, '', this)
            self.getGradesByQuarterAndYear();
          }

          // console.log(value)
        },
        loadUsers(loading, search, vm) {
            let self = this
            var siteId = ''
            var departmentId = ''
            var config = {
                headers: {
                    Authorization: 'Bearer ' + localStorage.getItem('api_token')
                }
            }
            var teamLead = "";
            // var myTeam = 1;

            console.log('self.view_manager == ', self.view_manager);

            if(self.view_manager != "" && self.view_manager != null) {
              console.log('1');
              teamLead = self.view_manager.id;
              // myTeam = "";
            } else {


              var userObj = localStorage.getItem("user_obj");
              var userJson = JSON.parse(userObj);
              // console.log('userJson', userJson);
              // if(userJson.role.id <=1) {
              //   console.log('3');
              //   teamLead = "";
              // } else {
              //   console.log('4');
              //   teamLead = userJson.id;
              // }

              teamLead = userJson.id;
              console.log('5');
              // myTeam = userObj.id;
            }

            var year = '';

            if(self.year === self.currentYear) {
              year = self.year;
            }


            console.log('6');
            var fields = {
                // search: '',
                except_self: 1,
                // myTeam: myTeam,
                notIn: self.selectedUsers,
                leaderId: teamLead,
                year: year,
            }

            console.log("my fields = ", fields)
            HTTP.post('getusersdropdown', fields, config)
                .then(function (response) {
                    self.sele_empArr = []
                    $.each(response.data.content, function (i) {
                        self.sele_empArr.push(response.data.content[i])
                    })
                    // if (typeof (loading) !== 'undefined') {
                    //     // loading(false)
                    // }
                })
                .catch(function (err) {
                  console.log("err = ", err);
                    if (err.response.status == 0) {
                        self.error = 'Remote server can not be reachable'
                    } else {
                        // redirect to login page if user not authenticated
                        if (err.response.status == 401) {
                            // clear previous data
                            localStorage.removeItem('user_obj')
                            localStorage.removeItem('api_token')
                            self.$router.push('/login')
                            // EventBus.$emit("logged-in", true, "", "");
                        }
                        self.error = err.response.data.message
                    }
                })
        },
        getGradesByQuarterAndYear: function () {

            if(self.view_manager != null && self.view_manager != "") {
              var param = {
                year: self.year,
                manager: self.view_manager.id,
             }
            } else {
              var userObj = localStorage.getItem("user_obj");
              var userJson = JSON.parse(userObj);
              // self.view_manager = {
              //   id : ,
              //   name : userJson.first_name + " " + userJson.last_name,
              //   role: userJson.role.name
              // }
              var param = {
                year: self.year,
                reporting_to: userJson.id,
             }
            }

            console.log("config =", param);

            var config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("api_token")
                },
                params: param
            };
            self.showLoader();
            HTTP.get('grades', config)
                .then(function (response) {
                    var listOfGrades = response.data.content.data;
                    // console.log(listOfGrades);
                    if (listOfGrades.length > 0) {

                        self.c1Emp = [];
                        self.c2Emp = [];
                        self.c3Emp = [];
                        self.b1Emp = [];
                        self.b2Emp = [];
                        self.b3Emp = [];
                        self.a1Emp = [];
                        self.a2Emp = [];
                        self.a3Emp = [];
                        self.selectedUsers = [];

                        self.selectedUsers = response.data.content.employees;
                        // self.sele_empArr

                        listOfGrades.forEach(element => {
                            switch (element.grade) {
                                case 'a1':
                                    self.a1Emp = element.employee;
                                    // var temp = _.pluck(self.a1Emp, 'value');
                                    // self.selectedUsers = selectedUsers.concat(temp);

                                    break;
                                case 'a2':
                                    self.a2Emp = element.employee;
                                    // var temp = _.pluck(self.a2Emp, 'value');
                                    // self.selectedUsers = selectedUsers.concat(temp);
                                    break;
                                case 'a3':
                                    self.a3Emp = element.employee;
                                    // var temp = _.pluck(self.a3Emp, 'value');
                                    // self.selectedUsers = selectedUsers.concat(temp);
                                    break;
                                case 'b1':
                                    self.b1Emp = element.employee;
                                    // var temp = _.pluck(self.b1Emp, 'value');
                                    // self.selectedUsers = selectedUsers.concat(temp);
                                    break;
                                case 'b2':
                                    self.b2Emp = element.employee;
                                    const iterator = self.b2Emp.keys();
                                    // var temp = _.pluck(self.b2Emp, 'value');
                                    // self.selectedUsers = selectedUsers.concat(temp);
                                    break;
                                case 'b3':
                                    self.b3Emp = element.employee;
                                    // var temp = _.pluck(self.b3Emp, 'value');
                                    // self.selectedUsers = selectedUsers.concat(temp);
                                    break;
                                case 'c1':
                                    self.c1Emp = element.employee;
                                    // var temp = _.pluck(self.c1Emp, 'value');
                                    // self.selectedUsers = selectedUsers.concat(temp);
                                    break;
                                case 'c2':
                                    self.c2Emp = element.employee;
                                    // var temp = _.pluck(self.c2Emp, 'value');
                                    // self.selectedUsers = selectedUsers.concat(temp);
                                    break;
                                case 'c3':
                                    self.c3Emp = element.employee;
                                    // var temp = _.pluck(self.c3Emp, 'value');
                                    // self.selectedUsers = selectedUsers.concat(temp);
                                    break;

                                default:
                                    break;
                            }

                        });

                    } else {

                        self.c1Emp = [];
                        self.c2Emp = [];
                        self.c3Emp = [];
                        self.b1Emp = [];
                        self.b2Emp = [];
                        self.b3Emp = [];
                        self.a1Emp = [];
                        self.a2Emp = [];
                        self.a3Emp = [];

                    }
                    self.loadUsers(true, '', this)
                    self.hideLoader();
                })
                .catch(function (err) {
                    if (err.response.status == 0) {
                        self.error = "Remote server can not be reachable";
                    } else {
                        //redirect to login page if user not authenticated
                        if (err.response.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("api_token");
                            localStorage.removeItem("profile_image");
                            //EventBus.$emit("logged-in", true, "", "");
                            self.$router.push("/login");
                        }
                        self.error = err.response.data.message;
                    }
                    self.hideLoader();
                });

        },
        showProfile: function (id) {
            $('#viewMore').modal('hide');
            localStorage.setItem("c1Emp", JSON.stringify(self.c1Emp));
            localStorage.setItem("c2Emp", JSON.stringify(self.c2Emp));
            localStorage.setItem("c3Emp", JSON.stringify(self.c3Emp));
            localStorage.setItem("b1Emp", JSON.stringify(self.b1Emp));
            localStorage.setItem("b2Emp", JSON.stringify(self.b2Emp));
            localStorage.setItem("b3Emp", JSON.stringify(self.b3Emp));
            localStorage.setItem("a1Emp", JSON.stringify(self.a1Emp));
            localStorage.setItem("a2Emp", JSON.stringify(self.a2Emp));
            localStorage.setItem("a3Emp", JSON.stringify(self.a3Emp));
            localStorage.setItem("quarter", self.quarter);
            localStorage.setItem("year", self.year);

            self.$router.push("/backend/talentprofile?id=" + id + "&from=9box&year=" + self.year);
        },
        checkUserExist: function (id) {

            var isValid = true;
            var idx = self.c1Emp.findIndex(obj => obj.value == id);
            if (idx != -1) {
                isValid = false;
            }
            var idx = self.b1Emp.findIndex(obj => obj.value == id);
            if (idx != -1) {
                isValid = false;
            }
            var idx = self.a1Emp.findIndex(obj => obj.value == id);
            if (idx != -1) {
                isValid = false;
            }
            var idx = self.c2Emp.findIndex(obj => obj.value == id);
            if (idx != -1) {
                isValid = false;
            }
            var idx = self.b2Emp.findIndex(obj => obj.value == id);
            if (idx != -1) {
                isValid = false;
            }
            var idx = self.a2Emp.findIndex(obj => obj.value == id);
            if (idx != -1) {
                isValid = false;
            }
            var idx = self.c3Emp.findIndex(obj => obj.value == id);
            if (idx != -1) {
                isValid = false;
            }
            var idx = self.b3Emp.findIndex(obj => obj.value == id);
            if (idx != -1) {
                isValid = false;
            }
            var idx = self.b3Emp.findIndex(obj => obj.value == id);
            if (idx != -1) {
                isValid = false;
            }
            return isValid;
        },
        addUserGrade: function (grade) {
            switch (grade) {
                case 'c1':
                    if (self.sele_empc1 != '') {
                        if(self.sele_empc1 != null) {
                            if (self.checkUserExist(self.sele_empc1.value)) {
                                if (self.c1Emp.length < 100) {
                                    if (!self.c1Emp.includes(self.sele_empc1)) {
                                        self.c1Emp.push(self.sele_empc1);
                                        self.selectedUsers.push(self.sele_empc1.value);
                                        var idx = self.sele_empArr.findIndex(obj => obj.value == self.sele_empc1.value);
                                        if (idx != -1) {
                                          self.sele_empArr.splice(idx, 1);
                                        }
                                        self.submitGrades();
                                        self.sele_empc1 = null;
                                        this.$refs.c1.clearSelection();
                                        // self.sele_empArr = [];
                                    }
                                } else {
                                    self.limitExide('C1 limit exide');
                                }
                            }
                        } else {
                            self.sele_empc1 = '';
                        }

                    }
                    break;
                case 'b1':
                    if (self.sele_empb1 != '') {
                        if(self.sele_empb1 != null) {
                            if (self.checkUserExist(self.sele_empb1.value)) {
                            if (self.b1Emp.length < 100) {
                                if (!self.b1Emp.includes(self.sele_empb1)) {
                                    self.b1Emp.push(self.sele_empb1);
                                    self.selectedUsers.push(self.sele_empb1.value);
                                    var idx = self.sele_empArr.findIndex(obj => obj.value == self.sele_empb1.value);
                                    if (idx != -1) {
                                      self.sele_empArr.splice(idx, 1);
                                    }
                                    self.submitGrades();
                                    self.sele_empb1 = null;
                                    this.$refs.b1.clearSelection();
                                }
                            } else {
                                self.limitExide('B1 limit exide');
                            }
                        }
                        } else {
                            self.sele_empb1 = '';
                        }
                    }
                    break;

                case 'a1':
                    if (self.sele_empa1 != '') {
                        if(self.sele_empa1 != null) {
                            if (self.checkUserExist(self.sele_empa1.value)) {
                                if (self.a1Emp.length < 100) {
                                    if (!self.a1Emp.includes(self.sele_empa1)) {
                                        self.a1Emp.push(self.sele_empa1);
                                        self.selectedUsers.push(self.sele_empa1.value);
                                        var idx = self.sele_empArr.findIndex(obj => obj.value == self.sele_empa1.value);
                                        if (idx != -1) {
                                          self.sele_empArr.splice(idx, 1);
                                        }
                                        self.submitGrades();
                                        this.$refs.a1.clearSelection();
                                        self.sele_empa1 = null;
                                        // self.sele_empArr = [];
                                    }
                                } else {
                                    self.limitExide('A1 limit exide');
                                }
                            }
                        } else {
                            self.sele_empa1 = '';
                        }
                    }

                    break;

                case 'c2':
                    if (self.sele_empc2 != '') {
                        if(self.sele_empc2 != null) {
                            if (self.checkUserExist(self.sele_empc2.value)) {
                                if (self.c2Emp.length < 100) {
                                    if (!self.c2Emp.includes(self.sele_empc2)) {
                                        self.c2Emp.push(self.sele_empc2);
                                        self.selectedUsers.push(self.sele_empc2.value);
                                        var idx = self.sele_empArr.findIndex(obj => obj.value == self.sele_empc2.value);
                                        if (idx != -1) {
                                          self.sele_empArr.splice(idx, 1);
                                        }
                                        self.submitGrades();
                                        this.$refs.c2.clearSelection();
                                        self.sele_empc2 = null;
                                        // self.sele_empArr = [];
                                    }
                                } else {
                                    self.limitExide('C2 limit exide');
                                }
                            }
                        } else {
                            self.sele_empc2 = '';
                        }

                    }

                    break;

                case 'b2':
                    if (self.sele_empb2 != '') {
                        if(self.sele_empb2 != null) {
                            if (self.checkUserExist(self.sele_empb2.value)) {
                                if (self.b2Emp.length < 100) {
                                    if (!self.b2Emp.includes(self.sele_empb2)) {
                                        self.b2Emp.push(self.sele_empb2);
                                        self.selectedUsers.push(self.sele_empb2.value);
                                        var idx = self.sele_empArr.findIndex(obj => obj.value == self.sele_empb2.value);
                                        if (idx != -1) {
                                          self.sele_empArr.splice(idx, 1);
                                        }
                                        self.submitGrades();
                                        this.$refs.b2.clearSelection();
                                        self.sele_empb2 = null;
                                        // self.sele_empArr = [];
                                    }
                                } else {
                                    self.limitExide('B2 limit exide');
                                }
                            }
                        } else {
                            self.sele_empb2 = '';
                        }
                    }
                    break;

                case 'a2':
                    if (self.sele_empa2 != '') {
                        if(self.sele_empa2 != null) {
                            if (self.checkUserExist(self.sele_empa2.value)) {
                                if (self.a2Emp.length < 100) {
                                    if (!self.a2Emp.includes(self.sele_empa2)) {
                                        self.a2Emp.push(self.sele_empa2);
                                        self.selectedUsers.push(self.sele_empa2.value);
                                        var idx = self.sele_empArr.findIndex(obj => obj.value == self.sele_empa2.value);
                                        if (idx != -1) {
                                          self.sele_empArr.splice(idx, 1);
                                        }
                                        self.submitGrades();
                                        this.$refs.a2.clearSelection();
                                        self.sele_empa2 = null;
                                        // self.sele_empArr = [];
                                    }
                                } else {
                                    self.limitExide('A2 limit exide');
                                }
                            }
                        } else {
                            self.sele_empa2 = '';
                        }
                    }

                    break;

                case 'c3':
                    if (self.sele_empc3 != '') {
                        if(self.sele_empc3 != null) {
                            if (self.checkUserExist(self.sele_empc3.value)) {
                                if (self.c3Emp.length < 100) {
                                    if (!self.c3Emp.includes(self.sele_empc3)) {
                                        self.c3Emp.push(self.sele_empc3);
                                        self.selectedUsers.push(self.sele_empc3.value);
                                        var idx = self.sele_empArr.findIndex(obj => obj.value == self.sele_empc3.value);
                                        if (idx != -1) {
                                          self.sele_empArr.splice(idx, 1);
                                        }
                                        self.submitGrades();
                                        this.$refs.c3.clearSelection();
                                        self.sele_empc3 = null;
                                        // self.sele_empArr = [];
                                    }
                                } else {
                                    self.limitExide('C3 limit exide');
                                }
                            }
                        } else {
                            self.sele_empc3 = '';
                        }
                    }

                    break;

                case 'b3':
                    if (self.sele_empb3 != '') {
                        if(self.sele_empb3 != null) {
                            if (self.checkUserExist(self.sele_empb3.value)) {
                                if (self.b3Emp.length < 100) {
                                    if (!self.b3Emp.includes(self.sele_empb3)) {
                                        self.b3Emp.push(self.sele_empb3);
                                        self.selectedUsers.push(self.sele_empb3.value);
                                        var idx = self.sele_empArr.findIndex(obj => obj.value == self.sele_empb3.value);
                                        if (idx != -1) {
                                          self.sele_empArr.splice(idx, 1);
                                        }
                                        self.submitGrades();
                                        this.$refs.b3.clearSelection();
                                        self.sele_empb3 = null;
                                        // self.sele_empArr = [];
                                    }
                                } else {
                                    self.limitExide('B3 limit exide');
                                }
                            }
                        } else {
                            self.sele_empb3 = '';
                        }
                    }

                    break;

                case 'a3':
                    if (self.sele_empa3 != '') {
                        if(self.sele_empa3 != null) {
                            if (self.checkUserExist(self.sele_empa3.value)) {
                                if (self.a3Emp.length < 100) {
                                    if (!self.a3Emp.includes(self.sele_empa3)) {
                                        self.a3Emp.push(self.sele_empa3);
                                        self.selectedUsers.push(self.sele_empa3.value);
                                        var idx = self.sele_empArr.findIndex(obj => obj.value == self.sele_empa3.value);
                                        if (idx != -1) {
                                          self.sele_empArr.splice(idx, 1);
                                        }
                                        self.submitGrades();
                                        this.$refs.a3.clearSelection();
                                        self.sele_empa3 = null;
                                        // self.sele_empArr = [];
                                    }
                                } else {
                                    self.limitExide('A3 limit exide');
                                }
                            }
                        } else {
                            self.sele_empa3 = '';
                        }
                    }
                    break;
                default:
                    break;
            }
        },
        limitExide: function (msg) {
            self.$swal({
                type: 'error',
                text: msg,
                showConfirmButton: false,
                timer: 5000,
            });
        }

    }
}
EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            if(self.roleId <= 1) {
              self.isVisibleMAnagers = true;
            }
            // self.loadUsers(true, '', this)
            console.log('self.roleId ==', self.roleId);

            self.userPermissions = userPermissions;
            self.roleName = name;
            self.system_year = system_year;
        }
    });
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.disableclick{
    pointer-events:none;
}


.disabledSelect {
  pointer-events:none;
  color: #bfcbd9;
  cursor: not-allowed;
  background-image: none;
  background-color: #eef1f6;
  border-color: #d1dbe5;
}
.talent-management .nine-box .v-select.searchable {
    width: 90%;
    display: inline-block;
}

.talent-management .nine-box .v-select.searchable .dropdown-toggle {
    border: 0;
    border-radius: 0;
    height: 26px;
    border-bottom: 2px solid #dddddd;
}

.talent-management .nine-box .v-select .dropdown-toggle .clear {
    top: -8px;
}

/* .v-select .vs__selected-options {margin: -8px;} */

.talent-management .top-header {
    width: 70%;
    margin-bottom: 20px;
}

.talent-management .top-header .v-select.searchable {
    float: right;
    width: 20%;
    margin: 0 10px 0 0;
}

.talent-management .top-header .v-select .selected-tag {
    height: 38px;
}

div#exportView .selected-tag {
  height: 38px;
}

.talent-management .top-header .filter .dropdown-toggle {
    border: 0;
    height: 38px;
    border-radius: 5px;
}

.talent-management .top-header .year-filter .dropdown-toggle {
    background-color: #f8f8f8;
}

.talent-management .top-header .quaters-filter .dropdown-toggle {
    background-color: #E5E5E5;
}

.talent-management .top-header .filter input[type=search] {
    height: auto;
}

.talent-management .toggle1,
.talent-management .toggle2 {
    float: left;
    width: 100%;
}

.talent-management .potential {
    width: 10%;
    float: left;
}

.talent-management .potential img {
    height: 400px;
}

.talent-management .performance {
    padding-left: 10%;
}

.talent-management .performance img {
    width: 100%;
    margin-top: 45px;
}

.talent-management .nine-box {
    width: 90%;
    float: left;
    display: block;
}

.talent-management .header .title {
    color: #14538E;
    font-family: 'SanFranciscoDisplaySemiBold';
    display: inline-block;
}

.talent-management .header span.search-section {
    float: right;
    width: 80%
}

.talent-management .header span.search-section i.plus-square {
    font-style: normal;
    color: #fff;
    background-color: #098de1;
    height: 20px;
    font-size: 22px;
    line-height: 17px;
    display: inline-block;
    width: 20px;
    text-align: center;
    border-radius: 2px;
    margin-top: 4px;
    cursor: pointer;
}

.talent-management .sections {
    border: 2px solid #098de1;
    padding: 5px 10px 15px;
    border-left: none;
    position: relative;
    border-bottom: none;
    min-height: 135px;
}

.talent-management .sections .priority {
    position: absolute;
    left: -50px;
    transform: rotate(270deg);
    top: 0;
    bottom: 0;
    color: #14538E;
    font-family: 'SanFranciscoDisplaySemiBold';
    text-transform: uppercase;
    width: 71px;
    height: 20px;
}

.talent-management .sections .avrpriority.priority {
    top: 30px;
}

.talent-management .sections .performance {
    position: absolute;
    left: 0;
    transform: rotate(0);
    bottom: -33px;
    color: #14538E;
    font-family: 'SanFranciscoDisplaySemiBold';
    text-transform: uppercase;
    text-align: center;
    width: 100%;
}

.talent-management .sections:first-child {
    border-left: 2px solid #098de1;
}

.talent-management .row:last-child .sections {
    border-bottom: 2px solid #098de1;
}

.talent-management input[type=text] {
    border: 0;
    border-radius: 0;
    border-bottom: 2px solid #dddddd;
}

.talent-management input[type=search] {
    height: 23px;
    padding: 0;
}

.talent-management input[type=text]::placeholder,
.talent-management input[type=search]::placeholder {
    font-size: 12px;
    font-style: italic;
    line-height: 20px;
}

.talent-management .nine-box .sections ul.list-user {
    padding-left: 25px;
    font-size: 14px;
    margin-top: 12px;
    width: 100%;
    display: inline-block;
}

.talent-management .nine-box .sections ul.list-user li {
    list-style: decimal;
    float: left;
    width: 50%;
    padding-right: 34px;
}

.talent-management .nine-box .sections ul.list-user li i {
    margin-left: 0 !important;
    cursor: pointer;
}

.talent-management .view-more {
    background-color: #2E8EE2;
    color: #fff;
    padding: 0.3rem 0.5rem;
    font-size: 0.8rem;
    line-height: 1.2;
    position: absolute;
    bottom: 7px;
    right: 10px;
    border-radius: 2px;
    width: auto !important;
}

.talent-management .toggle-content.mobile-content,
.talent-management .hide1 {
    display: none;
}

@media only screen and (max-width:812px) {
    .talent-management .forms-container {
        padding: 15px;
    }

    .talent-management .top-header {
        width: 100%;
        margin-bottom: 0;
    }

    .talent-management .top-header .btn {
        width: auto;
    }

    .talent-management .top-header .v-select.searchable {
        width: 30%;
    }

    .talent-management .toggle-title {
        background-color: #DB7A80;
        padding: 10px;
        color: #fff;
        font-size: 18px;
        margin-top: 20px;
        float: left;
        width: 100%;
    }

    .talent-management .toggle-title i {
        float: right;
        line-height: 32px;
    }

    .talent-management .nine-box .sections ul.list-user li {
        width: 100%;
    }

    .talent-management .sections .priority {
        left: -50px !important;
        width: 71px;
        height: 20px;
    }

    .talent-management .potential {
        width: 100%
    }

    .talent-management .potential img,
    .talent-management .performance img {
        display: none;
    }

    .talent-management .performance {
        padding-left: 0
    }

    .talent-management .nine-box {
        width: 94%;
        margin-left: 20px;
        margin-top: 10px;
    }

    .talent-management .sections {
        border-left: 2px solid #098de1;
    }

    .talent-management .row:last-child .sections {
        border-bottom: none;
    }

    .talent-management .row:last-child .sections:last-child {
        border-bottom: 2px solid #098de1;
    }

    .talent-management .toggle-content.mobile-content,
    .talent-management .hide1 {
        display: block;
    }

    .talent-management .desk-content {
        display: none;
    }

    .talent-management .show1 {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/backend/9box/9Box.vue